import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _TYPE_TO_MAPPER;

import _property from 'lodash/property';
import _curry from 'lodash/curry';
import _map from 'lodash/map';
import _identity from 'lodash/identity';
import _isFunction from 'lodash/isFunction'; // Formatter

import { getEmployeeLabel } from '../../formatters/accounting/employeeFormatter';
import getAccountLabel from '../../formatters/accounting/accountFormatter';
import getJournalLabel from '../../formatters/accounting/journalFormatter';
import { getUserLabel } from '../../formatters/accounting/userFormatter';
import { getUserName } from '../../formatters/parts/general'; // Readers

import employeeReader from '../../readers/Employee';
import accountReader from '../../readers/Account';
import distributionAllocationReader from '../../readers/ExpenseAllocation';
import journalReader from '../../readers/Journal';
import vendorReader from '../../readers/Vendor';
import purchaseOrderReader from '../../readers/PurchaseOrder';
import serviceTypeReader from '../../readers/ServiceType';
import dealerReader from '../../readers/Dealer';
import powerPostingReader from '../../readers/accounting/PowerPosting';
import oemSiteReader from '../../readers/OemSite';
import { RESOURCE_TYPE } from '../../bulkResolvers/constants/resourceType';
var ACCOUNT_MAPPER = {
  value: accountReader.id,
  label: getAccountLabel
};
var DISTRIBUTION_KEY_MAPPER = {
  value: distributionAllocationReader.id,
  label: distributionAllocationReader.distributionKey
};
var ACCOUNT_NUMBER_MAPPER = {
  value: accountReader.id,
  label: accountReader.accountNumber
};
var JOURNAL_MAPPER = {
  value: journalReader.id,
  label: getJournalLabel
};
var VENDOR_MAPPER = {
  value: vendorReader.id,
  label: vendorReader.vendorName
};
var EMPLOYEE_MAPPER = {
  value: employeeReader.id,
  label: getEmployeeLabel
};
var PURCHASE_ORDER_MAPPER = {
  value: purchaseOrderReader.universalId,
  label: purchaseOrderReader.poNumber
};
var POWER_POSTING_MAPPER = {
  value: powerPostingReader.name,
  label: powerPostingReader.displayName
};
export var DEFAULT_MAPPER = {
  value: _property('id'),
  label: _property('name')
};
var USER_MAPPER = {
  value: _property('userID'),
  label: getUserLabel
};
var FIELD_OPTION_MAPPER = {
  label: _identity,
  value: _identity
};
var VENDOR_SITE_MAPPER = {
  value: _property('id'),
  label: _property('siteName')
};
var SERVICE_TYPE_MAPPER = {
  value: serviceTypeReader.id,
  label: serviceTypeReader.name
};
var DEALER_MAPPER = {
  value: dealerReader.dealerId,
  label: dealerReader.dealerDisplayName
};
var PURCHASE_ORDER_TYPE_MAPPER = {
  value: _property('value'),
  label: _property('label')
};
var AUTO_POSTING_SETTINGS_MAPPER = {
  value: _property('label'),
  label: _property('displayName')
};
var PURCHASE_ORDER_ISSUED_BY_MAPPER = {
  value: _property('userID'),
  label: getUserName
};
var OEM_SITES_MAPPER = {
  value: _property('siteId'),
  label: _property('name')
};
var PREFERENCE_OEM_SITES_MAPPER = {
  value: oemSiteReader.siteId,
  label: oemSiteReader.name
};
var FORM_LICENSE_PROVIDER_MAPPER = {
  value: _property('legalProviderEnum'),
  label: _property('displayName')
};
var STATE_MAPPER = {
  value: _property('code'),
  label: _property('name')
};
var JOB_CODE_MAPPER = {
  value: _property('id'),
  label: _property('code')
};
var EEOC_MAPPER = {
  value: _property('eeocKey'),
  label: _property('eeocValue')
};
export var TYPE_TO_MAPPER = (_TYPE_TO_MAPPER = {
  ACCOUNT: ACCOUNT_MAPPER,
  ACCOUNT_NUMBER: ACCOUNT_NUMBER_MAPPER,
  JOURNAL: JOURNAL_MAPPER,
  VENDOR: VENDOR_MAPPER,
  EMPLOYEE: EMPLOYEE_MAPPER
}, _defineProperty(_TYPE_TO_MAPPER, RESOURCE_TYPE.USER_ID, USER_MAPPER), _defineProperty(_TYPE_TO_MAPPER, RESOURCE_TYPE.DEALER_USER, USER_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "PURCHASE_ORDER", PURCHASE_ORDER_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "VENDOR_SITE", VENDOR_SITE_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "SERVICE_TYPE", SERVICE_TYPE_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "FIELD_MAPPER", FIELD_OPTION_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "DISTRIBUTION_KEY", DISTRIBUTION_KEY_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "DEALER", DEALER_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "PURCHASE_ORDER_TYPE", PURCHASE_ORDER_TYPE_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "POWER_POSTING", POWER_POSTING_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "AUTO_POSTING_SETTINGS", AUTO_POSTING_SETTINGS_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "PURCHASE_ORDER_ISSUED_BY", PURCHASE_ORDER_ISSUED_BY_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "OEM_SITES", OEM_SITES_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "PREFERENCE_OEM_SITES", PREFERENCE_OEM_SITES_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "FORM_LICENSE_PROVIDER", FORM_LICENSE_PROVIDER_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "STATE", STATE_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "JOB_CODE", JOB_CODE_MAPPER), _defineProperty(_TYPE_TO_MAPPER, "EEOC", EEOC_MAPPER), _TYPE_TO_MAPPER);

var getDefaultMapper = function getDefaultMapper(mapper) {
  if (_isFunction(mapper === null || mapper === void 0 ? void 0 : mapper.value) && _isFunction(mapper === null || mapper === void 0 ? void 0 : mapper.label)) {
    return mapper;
  }

  return DEFAULT_MAPPER;
};

var mapStandardFieldToSelectOption = _curry(function (mapper, option) {
  var labelMapper = mapper.label;
  var valueMapper = mapper.value;
  return {
    label: labelMapper(option),
    value: valueMapper(option),
    additional: option
  };
});

var standardFieldOptionMapper = function standardFieldOptionMapper(type, options, optionsMapper) {
  var mapper = TYPE_TO_MAPPER[type] || getDefaultMapper(optionsMapper);
  return _map(options, mapStandardFieldToSelectOption(mapper));
};

export default standardFieldOptionMapper;